import { RouteComponentProps } from "@reach/router";
import { createElement, FC, useEffect } from "react";
import { TAppLayoutProps } from "../AppLayout/AppLayout";
import { useAppLayoutContext } from "../AppLayout/appLayoutContext";
import { globalHistory, useLocation } from "@reach/router";
import { useTrackPage } from "kanopi-components/tracking";

type TRouterOutlet = {
  component: unknown;
  isParent?: boolean;
  layoutOverrides?: TAppLayoutProps;
};
export const RouterOutlet: FC<TRouterOutlet & RouteComponentProps & unknown> = ({
  component,
  isParent = false,
  layoutOverrides,
  ...restProps
}) => {
  const { setContext: setAppLayoutOverrides } = useAppLayoutContext();
  const location = useLocation();
  const trackPage = useTrackPage({ now: false });

  useEffect(() => {
    // Do not set overrides for parent, it might cause re renders
    if (!isParent) {
      setAppLayoutOverrides(layoutOverrides);
    }

    return globalHistory.listen(() => {
      trackPage({ properties: { location } });
    });
  }, []);
  return createElement(component, restProps);
};
